import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MusicUploadSelectIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58173 0 0 3.58172 0 8C0 12.4183 3.58173 16 8 16ZM6.26794 7L8 10L9.73206 7H6.26794Z"
        fill={fillColor || '#F6F6F7'}
      />
    </svg>
  );
};

export { MusicUploadSelectIcon };
